import { Switch } from "@material-tailwind/react";

export function SwitchDefault() {
  return <Switch />;
}
